import { render, staticRenderFns } from "./SupportSidebar.vue?vue&type=template&id=6e7c4676"
import script from "./SupportSidebar.vue?vue&type=script&lang=js"
export * from "./SupportSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports